<template>
  <div class="row" ref="bagStep2" :class="classesCableSelectionWrapper">
    <LoadingOverlay
      :active.sync="displayLoader"
      id="loader"
      loader="dots"
      color="#1A74DB"
      height="30"
      width="100%"
      opacity="0.85"
    />
    <div v-if="bagStep < 2 && !isCableAccessoriesPage" class="cover-up"></div>
    <div class="col xs-12 md-12 lg-12" id="cable-selection">
      <div
        v-if="displayVehicleCableSelectionOptions"
        class="cable-selection-1"
        :class="classesOptions"
      >
        <Question
          v-if="showAdditionalAccessoryQuestion"
          :title="activeOffer.oneToOneAccessory.question_content.title"
          :subtitle="activeOffer.oneToOneAccessory.question_content.subtitle"
          :options="
            activeOffer.oneToOneAccessory.question_content.available_answers
          "
          :selectedOption="selectedAdditionalAccessoryOption"
          @onOptionClick="additionalAccessoryHandler"
        />
        <template>
          <div class="w-12/12 max-w-[1200px] md:flex justify-between">
            <div
              v-if="!isCableAccessoriesPage"
              class="w-12/12 mb-1 md:mb-0 md:w-5/12"
            >
              <p class="bold m-0 steps">Step 3 of {{ totalSteps }}</p>
              <h3
                class="bold leading-none text-blue-dark md:max-w-[300px] mb-1/2"
              >
                {{ webstoreContent.cartPage.specify_cables }}
              </h3>
              <p class="text-blue-dark text-normal mt-1/2 md:text-xl mb-2">
                {{
                  cableSelectionInstructions.replaceAll(
                    "(s)",
                    this.cablesNeededCount === 1 ? "" : "s"
                  )
                }}
              </p>
            </div>
            <div
              class="roboto text-center"
              :class="isCableAccessoriesPage ? 'w-12/12' : 'w-6/12'"
              v-if="displayNACableSelection"
            >
              <div
                class="cable-matching-options cursor-pointer w-4/12"
                v-if="showOptions('vin')"
                @click="handleOptionClick('vin')"
                id="vin"
              >
                <div
                  class="method-wrapper !w-auto flex flex-col p-1 mx-gap2 shadow--custom rounded-[14px] h-full min-h-[220px] md:min-h-[100px] md:p-2 border-3 border-white"
                  v-bind:class="cableOptionClass('vin')"
                >
                  <div
                    class="mb-1/2 tab--recommended w-full text-center text-sm text-white leading-[24px] rounded-[4px] font-semibold md:max-w-[130px] md:h-fit"
                  >
                    {{ webstoreContent.cartPage.recommended }}
                  </div>
                  <div class="pt-0 md:text-left md:w-9/12">
                    <h4 class="text-blue-dark text-xl font-bold md:m-0">
                      {{ webstoreContent.cartPage.input_vin_no_title }}
                    </h4>
                    <p class="text-blue-dark text-md">
                      {{ webstoreContent.cartPage.vin_sub }}
                    </p>
                  </div>
                </div>
              </div>

              <div
                class="cable-matching-options cursor-pointer w-4/12"
                v-if="showOptions('mmy')"
                @click="handleOptionClick('mmy')"
                id="mmy"
              >
                <div
                  class="method-wrapper !w-auto flex flex-col p-1 mx-gap2 shadow--custom rounded-[14px] h-full min-h-[220px] md:min-h-[100px] md:p-2 border-3 border-white"
                  v-bind:class="cableOptionClass('mmy')"
                >
                  <div
                    class="mb-1/2 tab--recommended bg-blue-default w-full text-center text-sm text-white leading-[24px] rounded-[4px] font-semibold md:max-w-[130px] md:h-fit"
                  >
                    {{ webstoreContent.cartPage.recommended }}
                  </div>
                  <div class="pt-0 md:text-left md:w-9/12">
                    <h4 class="text-blue-dark text-xl font-bold md:m-0">
                      {{
                        activeProductKey.includes("AG")
                          ? webstoreContent.cartPage.asset_selection_title
                          : webstoreContent.cartPage.vehicle_selection_title
                      }}
                    </h4>
                    <p class="text-blue-dark text-md">
                      {{
                        activeProductKey.includes("AG")
                          ? webstoreContent.cartPage.asset_sub
                          : webstoreContent.cartPage.make_model_sub
                      }}
                    </p>
                  </div>
                </div>
              </div>

              <div
                class="cable-matching-options cursor-pointer w-4/12"
                v-if="showOptions('plug type')"
                @click="handleOptionClick('plug type')"
                id="plug-type"
              >
                <div
                  class="method-wrapper !w-auto flex flex-col p-1 mx-gap2 shadow--custom rounded-[14px] h-full min-h-[220px] md:min-h-[120px] md:p-2 border-3 border-white"
                  v-bind:class="cableOptionClass('plug type')"
                >
                  <div class="pt-0 md:text-left md:w-9/12 md:mt-0">
                    <h4 class="text-blue-dark text-xl font-bold md:m-0">
                      {{ webstoreContent.cartPage.plug_type }}
                    </h4>
                    <p class="text-blue-dark text-md">
                      {{
                        activeProductKey.includes("AG")
                          ? webstoreContent.cartPage.asset_type_sub
                          : webstoreContent.cartPage.cable_type_sub
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row flex flex-row" v-else>
              <div
                class="cable-matching-options cursor-pointer w-1/3"
                v-bind:class="cableOptionClass('emea-mmy-selection')"
                @click="changeCableMethod('emea-mmy-selection')"
                id="mmy"
              >
                {{ webstoreContent.cartPage.vehicle_selection_title }}
              </div>
            </div>
          </div>
        </template>
      </div>
      <div
        class="h-fit"
        :ref="
          isCableAccessoriesPage
            ? 'cableSelect'
            : displayVehicleCableSelectionOptions
            ? 'bagStep3'
            : 'bagStep2'
        "
        :class="[
          displayVehicleCableSelectionOptions
            ? bagStep < 3 && !isCableAccessoriesPage && 'grayed'
            : bagStep < 2 && 'grayed',
          isCableAccessoriesPage
            ? 'overflow-visible'
            : 'overflow-hidden md:h-screen',
        ]"
      >
        <div
          v-if="
            (!isCableAccessoriesPage &&
              displayVehicleCableSelectionOptions &&
              bagStep < 3) ||
            (!displayVehicleCableSelectionOptions && bagStep < 2)
          "
          class="cover-up"
        ></div>
        <div
          id="selection-options"
          class="padding-bottom"
          v-if="displayNACableSelection"
        >
          <div class="w-12/12 max-w-[1200px] md:flex justify-between">
            <div v-if="!isCableAccessoriesPage" class="w-12/12 md:w-4/12">
              <div class="roboto">
                <p class="bold m-0 md:text-left steps">
                  Step {{ onlyOneCableSelectionMethod ? "3" : "4" }} of
                  {{ totalSteps }}
                </p>
                <h3 class="text-blue-dark md:text-left md:mb-1/2 md:mt-1/2">
                  {{
                    webstoreContent.cartPage.general_cable_select
                      .replace(
                        "cables_needed_count",
                        this.cablesNeededCount === 1
                          ? ""
                          : this.cablesNeededCount
                      )
                      .replaceAll(
                        "(s)",
                        this.cablesNeededCount === 1 ? "" : "s"
                      )
                  }}
                </h3>
                <p class="mt-1/2 text-blue-dark text-xl">
                  {{
                    totalCablesSubmittedCount === 0
                      ? "No cables selected"
                      : `${totalCablesSubmittedCount} out of ${cablesNeededCount} cables selected`
                  }}
                  <span
                    class="check"
                    v-if="totalCablesSubmittedCount === cablesNeededCount"
                    >&#10003;</span
                  >
                </p>
              </div>
              <SelectionInfo
                :cableSkuToNames="cableSkuToNames"
                @change-cable-selection-type="changeCableMethodEvent"
                @add-selection-method="addCableSelectionMethod"
                @clear="clearAllData"
                :shift="false"
              />
            </div>
            <div
              class="cable-type-select mt-1"
              :class="isCableAccessoriesPage ? 'w-12/12' : 'md:mt-0 md:w-7/12'"
            >
              <div
                ref="desktopScrollWrapper"
                class="cable-scroll-wrapper h-fit p-b-8"
                :class="
                  isCableAccessoriesPage
                    ? 'overflow-visible'
                    : 'md:h-screen overflow-scroll'
                "
              >
                <div :class="isCableAccessoriesPage ? '' : 'padding-wrapper'">
                  <template
                    v-for="(method, index) in activeCableSelectionMethods"
                  >
                    <component
                      :key="method"
                      :is="cableMethodComponent(method)"
                      :ref="method"
                      :addToCart="addToCart"
                      :isCableAccessoriesPage="isCableAccessoriesPage"
                      :selectedTypeOfReplacementCable="
                        selectedTypeOfReplacementCable
                      "
                      :noProductImage="webstoreContent.noProductImage"
                      :webstoreContent="webstoreContent"
                    >
                      <template slot="title">
                        <div
                          class="flex justify-between cable-title-border pt-1 pb-0"
                        >
                          <h3 class="text-blue-dark text-xl mt-0 mb-0">
                            {{
                              webstoreContent.cartPage
                                .specific_cable_selection_title[
                                activeProductKey.includes("AG") &&
                                method === "mmy"
                                  ? "mmyAG"
                                  : method
                              ]
                            }}
                          </h3>
                          <div
                            class="close-out"
                            @click="removeCableSelectionMethod(method, index)"
                          >
                            <Trash />
                          </div>
                        </div>
                        <p
                          v-if="
                            webstoreContent.cartPage
                              .specific_cable_selection_subtitle[
                              activeProductKey.includes('AG') &&
                              method === 'mmy'
                                ? 'mmyAG'
                                : method
                            ]
                          "
                          class="text-blue-dark text-base mt-1/2 mb-0 pb-1"
                        >
                          {{
                            webstoreContent.cartPage
                              .specific_cable_selection_subtitle[
                              activeProductKey.includes("AG") &&
                              method === "mmy"
                                ? "mmyAG"
                                : method
                            ]
                          }}
                        </p>
                      </template>
                    </component>
                  </template>
                  <SelectionInfo
                    v-if="isCableAccessoriesPage"
                    :isCableAccessoriesPage="isCableAccessoriesPage"
                    :cableSkuToNames="cableSkuToNames"
                    @change-cable-selection-type="changeCableMethodEvent"
                    @add-selection-method="addCableSelectionMethod"
                    @clear="clearAllData"
                    :shift="false"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="selection-options" v-else>
          <EmeaMmyInput
            v-show="mainSelectCableMethod == 'emea-mmy-selection'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { titleCase, uncamelize } from "../../utils";
import ManualSelection from "./manual-selection";
import MmyInput from "./mmy-input";
import VinInput from "./vin-input";
import EmeaMmyInput from "./emea-mmy-input";
import Notice from "../utils/notice";
import Question from "../utils/question";
import AdditionalAccessoryQuestionMixin from "../../mixins/additional-accessory-question";
import { WebstoreResources } from "../../mixins/webstore-resources";
import { cableSelectionAvailableOptions } from "../../settings";
import { analyticsTrack } from "../../../vue/plugins/segment";
import SelectionInfo from "../utils/selection-info.vue";
import Plus from "../utils/icons/plus.vue";
import Trash from "../utils/icons/trash.vue";

export default {
  mixins: [AdditionalAccessoryQuestionMixin, WebstoreResources],

  props: {
    bagStep: {
      required: true,
      type: Number,
    },
    productName: {
      required: true,
      type: String,
    },
    addToCart: {
      type: Boolean,
      default: false,
    },
    isCableAccessoriesPage: {
      type: Boolean,
      default: false,
    },
    activeCableSelectionMethods: {
      required: true,
      type: Array,
    },
    selectedTypeOfReplacementCable: {
      required: false,
      type: String,
    },
  },

  components: {
    ManualSelection,
    MmyInput,
    VinInput,
    EmeaMmyInput,
    Notice,
    Question,
    SelectionInfo,
    Plus,
    Trash,
  },

  data() {
    return {
      mainSelectCableMethod: "",
      cableSelectionAvailableOptions: cableSelectionAvailableOptions,
      displayLoader: false,
    };
  },

  computed: {
    mmyData() {
      return this.$store.getters[
        `${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/mmyData`
      ];
    },

    cableSelectionInstructions() {
      return this.activeProductKey.includes("AG")
        ? this.webstoreContent.cartPage.select_asset_cable_instructions
        : this.webstoreContent.cartPage.select_cable_instructions;
    },

    cableSkuToNames() {
      let cableNames = {};
      let typeOfProductCable = this.activeProductKey.includes("AG")
        ? "AG-CBL"
        : "VG-CBL";
      if (
        "CBL" in this.productCatalog &&
        typeOfProductCable in this.productCatalog.CBL
      ) {
        let cablesAvailable =
          this.productCatalog.CBL[typeOfProductCable].offerings;
        for (let cableKey in cablesAvailable) {
          cableNames[cableKey] = cablesAvailable[cableKey].offerName;
        }
      }
      return cableNames;
    },
    classesCableSelectionWrapper() {
      if (
        (this.bagStep < 2 && !this.isCableAccessoriesPage && "grayed",
        this.isCableAccessoriesPage)
      ) {
        return "";
      } else {
        return "cable-selection-wrapper md:mb-5 md:mt-5";
      }
    },
    classesOptions() {
      if (this.isCableAccessoriesPage && !this.selectedTypeOfReplacementCable) {
        return "grayed";
      } else if (
        this.isCableAccessoriesPage &&
        this.selectedTypeOfReplacementCable
      ) {
        return "";
      } else {
        return "min-h-screen mb-5";
      }
    },
  },

  methods: {
    updateBagStep(step) {
      this.bagStep = step;
      this.$emit("updateBagStep", step);
    },
    handleOptionClick(optionValue) {
      if (this.isCableAccessoriesPage && !this.selectedTypeOfReplacementCable) {
        return;
      }
      this.changeCableMethod(optionValue);
      this.scrollTo(3);
      this.addCableSelectionMethod(optionValue, true);
    },
    scrollTo(step) {
      this.$emit("scroll-to", step);
    },

    addCableSelectionMethod(method, reset) {
      this.$emit("add-selection-method", method, reset);
    },

    removeCableSelectionMethod(method, index) {
      // Don't remove the first / only method, just clear
      if (index !== 0) {
        this.$emit("remove-selection-method", method);
        this.$refs["desktopScrollWrapper"].scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }

      const storeMap = {
        "plug type": "manualSelection/clearManualSelectionData",
        vin: "vin/clearVinData",
        mmy: "mmy/clearMMYData",
      };

      // Call the function within the method element to clear
      return this.$store.commit(
        `${this.activeProductKey}${this.activeOfferKey}CableSelection/${storeMap[method]}`
      );
    },

    clearAllData() {
      this.displayLoader = true;
      this.updateBagStep(4);
      // VIN MMY and Manual selection subscribe to this to clear their data respectively
      this.$store.commit(
        `${this.activeProductKey}${this.activeOfferKey}CableSelection/base/clearTotalCablesSubmittedData`
      );
      setTimeout(() => {
        this.displayLoader = false;
        this.scrollTo(3);
      }, 1000);
    },

    clearVinData() {
      return this.$store.commit(
        `${this.activeProductKey}${this.activeOfferKey}CableSelection/vin/clearVinData`
      );
    },

    addMMYRow() {
      return this.$store.commit(
        `${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/addMMYRow`
      );
    },

    addEmeaMMYRow() {
      return this.$store.commit(
        `${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/addEmeaMMYRow`
      );
    },

    clearMMYRow() {
      return this.$store.commit(
        `${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/clearMMYData`
      );
    },

    clearManualSelectionData() {
      return this.$store.commit(
        `${this.activeProductKey}${this.activeOfferKey}CableSelection/manualSelection/clearManualSelectionData`
      );
    },

    changeCableMethod: function (cableMethod) {
      this.mainSelectCableMethod = cableMethod;
      this.setCableSelectionMessage("");
      analyticsTrack("Cable Method Chosen", { cable_method: cableMethod });
    },

    changeCableMethodEvent: function (cableMethod) {
      this.changeCableMethod(cableMethod);
      this.setCableSelectionMessage("");
    },

    cableOptionClass: function (selectedOption) {
      return {
        selected: selectedOption == this.mainSelectCableMethod,
      };
    },

    showOptions(option) {
      return this.cableSelectionAvailableOptions[
        this.activeProductKey
      ].includes(option);
    },

    addMMYRowHandler() {
      if (this.displayNACableSelection) {
        if (this.mmyData && this.mmyData.length === 0) {
          this.addMMYRow();
        }
      } else {
        this.mainSelectCableMethod = "emea-mmy-selection";
        if (this.mmyData.length === 0) {
          this.addEmeaMMYRow();
        }
      }
    },

    cableMethodComponent(method) {
      if (method === "vin") {
        return VinInput;
      } else if (method === "mmy") {
        return MmyInput;
      } else {
        return ManualSelection;
      }
    },

    updateBarShown(shown) {
      this.$emit("update-bottom-bar", shown);
    },

    updateBarActions(cableSelection) {
      this.$emit("update-bottom-bar-action", cableSelection);
    },

    handleScroll() {
      let refString = "bagStep3";
      if (this.totalSteps === 4) {
        refString = "bagStep2";
      }
      let stepThreeHeight =
        this.$refs[refString] &&
        this.$refs[refString].offsetTop - this.$refs[refString].offsetHeight;
      let stepThreeBottom =
        this.$refs[refString] && this.$refs[refString].offsetTop;
      if (stepThreeHeight > window.scrollY) {
        this.updateBarShown(false);
      } else {
        this.updateBarShown(true);
      }
      if (stepThreeBottom + 300 > window.scrollY) {
        this.updateBarActions(true);
      } else {
        this.updateBarActions(false);
      }
    },

    typeOfCableSelectionText(type, customerInput) {
      if (type === "mmy") {
        customerInput = customerInput
          .split("_")
          .map((input) => {
            if (input.toLowerCase() !== "not applicable") {
              if (isNaN(parseFloat(input))) {
                return input === input.toUpperCase()
                  ? titleCase(input.toLowerCase())
                  : titleCase(uncamelize(input));
              } else {
                return input;
              }
            } else {
              return "";
            }
          })
          .join(" ");
        return `${this.webstoreContent.selectProductsPage.for_mmy} ${customerInput}`;
      } else if (type === "manualSelection") {
        return this.webstoreContent.selectProductsPage.by_plug_type;
      } else {
        return `${this.webstoreContent.selectProductsPage.for_vin} ${customerInput}`;
      }
    },
  },

  watch: {
    cablesNeededCount: function () {
      if (this.cablesNeededCount === 0) {
        this.clearVinData();
        this.clearManualSelectionData();
        this.clearMMYRow();
      }
    },
    activeOfferKey: {
      handler: function () {
        this.addMMYRowHandler();
      },
      immediate: true,
    },
  },

  created() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (
        [
          `${this.activeProductKey}${this.activeOfferKey}CableSelection/vin/setSubmittedVinData`,
          `${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/setSubmittedMMYData`,
          `${this.activeProductKey}${this.activeOfferKey}CableSelection/manualSelection/setManuallySelectedCableAndQuantity`,
          `${this.activeProductKey}${this.activeOfferKey}CableSelection/manualSelection/setManualSelectionData`,
          `${this.activeProductKey}${this.activeOfferKey}CableSelection/vin/clearSubmittedVinData`,
          `${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/clearSubmittedMMYData`,
          `${this.activeProductKey}${this.activeOfferKey}CableSelection/manualSelection/clearManualSelectionData`,
        ].includes(mutation.type)
      ) {
        this.setCablesSelectedCount();
        this.setTotalCablesSubmittedData();
      }
    });

    window.addEventListener("scroll", this.handleScroll);

    this.mainSelectCableMethod = ["GBP", "EUR"].includes(this.currencyIsoCode)
      ? "emea-mmy-selection"
      : undefined;

    // Auto set the cable selection method if only one is available
    if (this.onlyOneCableSelectionMethod) {
      this.addCableSelectionMethod(
        this.cableSelectionAvailableOptions[this.activeProductKey][0],
        true
      );
      this.changeCableMethod(
        this.cableSelectionAvailableOptions[this.activeProductKey][0]
      );
    }
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>

<style scoped>
.flex {
  width: 100%;
  display: flex;
}
@media (max-width: 768px) {
  .cable-selection-1 {
    margin-bottom: 300px;
  }
  .section-margin-5 {
    margin-top: 0;
  }
}

.flex-around {
  align-items: center;
  justify-content: space-around;
}

.flex-between {
  align-items: center;
  justify-content: space-between;
}

.cable-selection-wrapper {
  margin-top: 100px;
}

.steps {
  color: #8390a0;
}

.flex-wrap {
  flex-wrap: wrap;
}

#cable-selection {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: normal;
  line-height: 30px;
  padding-left: 0px;
  padding-right: 0px;
}

.cable-title {
  font-size: 24px;
  font-weight: 500;
  margin-left: 20px;
  margin-bottom: 10px;
}

.cable-text {
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
}

.check {
  height: 25px;
  width: 25px;
  border-radius: 100%;
  background-color: #0db010;
  font-size: 17px;
  line-height: 17px;
  display: inline-flex;
  color: white;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
  padding-top: 2px;
}

.cable-selection-type {
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
}

#header {
  font-size: 34px;
  font-weight: 500;
  color: #2e3438;
}

#instructions {
  font-size: 24px;
  color: #474f54;
  margin: 30px 0px;
}

.cables-selected-prompt {
  font-size: 24px;
}

#cable-selection-incomplete {
  font-weight: bold;
  color: #bb2200;
}

#cables-selected-complete {
  color: black;
}

.cable-selections {
  border-bottom: 1px solid #e4e7eb;
}

.selected {
  border: 3px solid #0384fb;
}
.shadow--custom {
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
}
.tab--recommended {
  background: #f2f7ff;
  color: #0384fb;
}
.grayed {
  opacity: 0.4;
  overflow: hidden;
}
.grayed .cable-matching-options {
  cursor: not-allowed;
}
.cable-matching-options {
  min-width: 330px;
  margin-bottom: 30px;
}
.cable-title-border {
  border-top: 2px solid #f0f0f0;
}
@media (min-width: 736px) {
  .cable-matching-options {
    margin-bottom: 30px;
    width: 100%;
  }
  .method-wrapper {
    flex-direction: row-reverse;
    justify-content: flex-end;
    position: relative;
  }
  .tab--recommended {
    height: fit-content;
    position: absolute;
    right: 35px;
    top: 35px;
  }
  .modal-click-wrapper {
    text-align: left !important;
  }
  .padding-wrapper {
    padding-bottom: 500px;
  }
  .cable-title-border {
    margin-right: 20px;
  }
  .close-out {
    font-size: 1.25rem;
    line-height: 1;
    color: gray;
    cursor: pointer;
    margin: 0;
  }
}
.cover-up {
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 10;
  left: 0;
}
.inactive {
  opacity: 0.4;
}
.inactive:hover {
  color: rgb(1, 132, 251) !important;
  background: white !important;
}
.active {
  border: 3px solid #0384fb;
}
</style>
